import React from 'react';
import { Typography, Box, TextField } from '@mui/material';

import type { SupplierRegistrationForm, QualifiedPersonnel } from '../../types/company.types';

import { getStylesForEditableField } from '@/utils/helpers';
import { PaperBoxStyles } from '@/components/styles';

interface QualifiedPersonnelSectionProps {
  qualifiedPersonnel: QualifiedPersonnel;
  originalQualifiedPersonnel?: QualifiedPersonnel;
  isEditMode?: boolean;
  onUpdateField: (
    field: keyof SupplierRegistrationForm['qualifiedPersonnel'],
    value: string | number
  ) => void;
  getFieldError: (field: string) => string | undefined;
  isFieldValid: (field: string) => boolean;
}

export const QualifiedPersonnelSection: React.FC<QualifiedPersonnelSectionProps> = ({
  qualifiedPersonnel,
  originalQualifiedPersonnel,
  isEditMode,
  onUpdateField,
  getFieldError,
  isFieldValid,
}) => {
  const personnelFields = [
    { key: 'professionalEngineers', label: '技術士（建設部門）', unit: '名' },
    { key: 'concreteDiagnosticians', label: 'コンクリート診断士', unit: '名' },
    { key: 'seniorConcreteTechnicians', label: 'コンクリート主任技士', unit: '名' },
    { key: 'concreteTechnicians', label: 'コンクリート技士', unit: '名' },
  ];

  const handleNumericChange = (fieldKey: string, value: string) => {
    onUpdateField(fieldKey as keyof SupplierRegistrationForm['qualifiedPersonnel'], value);
  };

  return (
    <PaperBoxStyles elevation={1} sx={{ mb: 2, paddingBottom: '32px' }}>
      <Typography
        variant='h5'
        fontWeight='bold'
        sx={{
          mb: 3,
          color: '#1A1C20',
          fontSize: '22px',
          fontWeight: 600,
        }}
      >
        資格取得者
      </Typography>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
        {personnelFields.map((field) => {
          const originalValue = originalQualifiedPersonnel?.[field.key as keyof QualifiedPersonnel];
          const newValue = qualifiedPersonnel?.[field.key as keyof QualifiedPersonnel];
          return (
            <TextField
              key={field.key}
              label={`${field.label}（${field.unit}）`}
              value={newValue ?? ''}
              placeholder={`取得者数を入力してください（半角数値）`}
              onChange={(e) => handleNumericChange(field.key, e.target.value)}
              error={!isFieldValid(`qualifiedPersonnel.${field.key}`)}
              helperText={getFieldError(`qualifiedPersonnel.${field.key}`)}
              fullWidth
              slotProps={{
                input: {
                  inputProps: {
                    inputMode: 'numeric',
                    pattern: '[0-9]*',
                    maxLength: 9,
                  },
                  sx: getStylesForEditableField(!!isEditMode, originalValue, newValue),
                },
              }}
            />
          );
        })}
      </Box>
    </PaperBoxStyles>
  );
};
